import { Injectable } from '@angular/core';
import { ApiArrayResponse, ApiEndpoints, ApiService } from '@nano/core/api';
import { Observable } from 'rxjs';
import { PartyBeneficiary } from './party-beneficiaries';

@Injectable({ providedIn: 'root' })
export class PartyBeneficiariesService {
  constructor(private apiService: ApiService) {}

  getBeneficiaries(query?: string, limit?: number, skip?: number): Observable<ApiArrayResponse<PartyBeneficiary>> {
    return this.apiService.get<ApiArrayResponse<PartyBeneficiary>>(ApiEndpoints.partyBeneficiariesList(query, limit, skip));
  }
}
